module.exports = __webpack_public_path__ + "img/closeRedDamask.02ab4f0c.svg";